import { buildAxiosInstance, buildAxiosWithoutInterceptors, buildMakeUseAxios } from "@root/api/api.tools";

const baseUrl = `${import.meta.env.VITE_ENTERPRISE_SERVICE_URL}/partners/structure`;
export const axiosStructurePartner = buildMakeUseAxios(baseUrl);
export const axiosStructurePartnerWithoutInterceptor = buildAxiosWithoutInterceptors(baseUrl);
export const axiosStructurePartnerInstance = buildAxiosInstance(baseUrl);
